import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import Cookies from "universal-cookie";
import AemService from "./helpers/aemService";

const cookies = new Cookies();
const service = new AemService();

let language = cookies.get("language");
if (language !== "it-IT" && language !== "en-EN"){
  language="it-IT";
  cookies.set(
    "language",
    "it-IT",
  );
}
const fallBackCatalogue =  async (lang) => {
  const response = await fetch(
    `${process.env.PUBLIC_URL}/locales/${lang}/translation.json`
  );
  if (!response.ok) {
    console.log("Load IT translation not found. Aborting. ");
    throw new Error("HTTP error " + response.status);
  }
  return response.json();
};

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources: {},
    lng: language || "it-IT",
    fallbackLng: ["it-IT", "en-EN"],
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
      useSuspense: true,
      defaultTransParent: "div",
    },
  });
// const allCatalogue = async () => {
//   return await Promise.all([
//     await fallBackCatalogue('it-IT'),
//     await fallBackCatalogue('en-EN')
//   ]).then((values) => {
//       const [it, en] = values;
//       i18n.addResources('it-IT', 'translation', it);
//       i18n.addResources('en-EN', 'translation', en);
//     }
//   )
// }
// allCatalogue().then(res => console.info('# local catalog loaded')).catch(e => console.error(e));
// service.getTranslations('en-EN').then((response) => {
//   i18n.addResourceBundle('en-EN', 'translation', response);
// });
// service.getTranslations('it-IT').then((response) => {
//   i18n.addResourceBundle('it-IT', 'translation', response);
// });

// use this to force translations BEFORE they get to AEM
// you should remove an entry if already correctly translated
const overwriteKeysIt = {}
const overwriteKeysEn = {}

const loadTranslations = () => {
  Promise.all([
    service.getTranslations("en-EN"),
    service.getTranslations("it-IT"),
  ])
    .then(([enTranslations, itTranslations]) => {
      const enTrans = {...enTranslations, ...overwriteKeysEn};
      const itTrans = {...itTranslations, ...overwriteKeysIt};

      i18n.addResourceBundle("en-EN", "translation", enTrans);
      i18n.addResourceBundle("it-IT", "translation", itTrans);
    })
    .catch((error) => {
      Promise.all([fallBackCatalogue("it-IT"), fallBackCatalogue("en-EN")])
        .then((values) => {
          const [it, en] = values;
          i18n.addResources("it-IT", "translation", it);
          i18n.addResources("en-EN", "translation", en);
          console.log("Setting translations from local");
        })
        .catch(() => {
          console.error("Could not load translations");
        });
    });
};

const loadTranslationsFromLocal = () => {
  Promise.all([fallBackCatalogue("it-IT"), fallBackCatalogue("en-EN")])
    .then((values) => {
      const [it, en] = values;
      i18n.addResources("it-IT", "translation", it);
      i18n.addResources("en-EN", "translation", en);
      console.log("Setting translations from local");
    })
    .catch((error) => {
      console.error("Could not load translations",error);
    });
};

loadTranslations();
//loadTranslationsFromLocal();
const local = false;
if (local) {
  loadTranslationsFromLocal();
}

if (language) {
  i18n.changeLanguage(language);
}

export default i18n;
